import { useEffect, useState } from "react";
import React from "react";
import NivoBarchart from "../../../Nivo/Nivo_Barchart";

import { downloadPDF } from "../../../ChartsJs/DownlaodExportImage";
import StackedBarChart from "../../../ChartsJs/StatckedBar";
import BarChart from "../../../ChartsJs/SingleBarchart";
import { baseURL } from "../../../Util/axios_helper";
import { KendoGrid } from "../../../Kendo/kendo_grid";
import { PdfModal } from "../../../Util/common";

const IncomingText = ({
  IncomingMessage,
  type,
  refresh,
  filter,
  Year,
  metric,
  value,
}) => {
  const [xAxisLabel, setxAxislabel] = useState([]);
  const [data, setData] = useState([]);
  useEffect(() => {
    if (IncomingMessage != undefined) {
      const xaxis = IncomingMessage.map((e) => e.Xaxis);
      const data = IncomingMessage.map((e) => e.Count);
      setxAxislabel(xaxis);
      setData(data);
    }
  }, [IncomingMessage, refresh]);

  const [flag, setflag] = useState(false);
  const [refreshflag, setrefreshflag] = useState(0);

  return (
    <div className="card">
      <div className="col-xs-12 mt-2 files">
        {/* <div
          className="ms-2 me-2 "
          title="Export to Pdf"
          style={{
            position: "relative",
            float: "right",
            cursor: "pointer",
          }}
          onClick={() => downloadPDF("IncomingText", "Incoming Text", 55, 3)}
        >
          <span className="files-icon">
            <i class="las la-image"></i>
          </span>
        </div> */}
        <a
          href={`#`}
          onClick={() => {
            var modal = document.getElementById("INTextPDFmodal");
            modal.style.display = "block";
            var span = document.getElementById("INTextPDFclose");
            span.onclick = function () {
              modal.style.display = "none";
            };

            // When the user clicks anywhere outside of the modal, close it
            window.onclick = function (event) {
              if (event.target == modal) {
                modal.style.display = "none";
              }
            };
          }}
        >
          <div
            title="View Report"
            className="ms-2 me-2"
            style={{
              position: "relative",
              float: "right",
              cursor: "pointer",
            }}
          >
            <span className="files-icon">
              <i className="las la-image"></i>
            </span>
          </div>
        </a>
        <a
          href="#"
          onClick={() => {
            var modal = document.getElementById("itModal");
            modal.style.display = "block";

            var span = document.getElementById("itclose");
            span.onclick = function () {
              modal.style.display = "none";
            };

            // When the user clicks anywhere outside of the modal, close it
            window.onclick = function (event) {
              if (event.target == modal) {
                modal.style.display = "none";
              }
            };
            setflag(true);
            setrefreshflag(refreshflag + 1);
          }}
        >
          <div
            title="View Report"
            className=""
            style={{
              position: "relative",
              float: "right",
              cursor: "pointer",
            }}
          >
            <span className="files-icon">
              <i className="las la-file-alt"></i>
            </span>
          </div>
        </a>
      </div>

      <div className="card-body">
        <div style={{ height: 300, fontWeight: "bold" }}>
          <div style={{ textAlign: "center" }}>Incoming Text</div>
          {/* <NivoBarchart
            data={IncomingCalls}
            indexBy={"month"}
            keys={["IncomingCall"]}
            xAxisLabel="Months"
            yAxisLabel="Incoming Calls"
            IsIncomingCall={true}
            groupMode={"stacked"}
          /> */}
          {/* <StackedBarChart type={"bar"} XAxisLabel={xAxisLabel} /> */}
          <BarChart
            labels={xAxisLabel}
            Bardata={data}
            type={"x"}
            // title={"Incoming Text"}
            XAxisLabel={type}
            YAxisLabel={"Count"}
            id={"IncomingText"}
          />
        </div>
      </div>
      {/* Modal component */}
      <div id="itModal" class="cmodal">
        <div class="cmodal-content">
          <div className="modal-header">
            <h5 className="modal-title-popup">Incoimg Text Report</h5>
            <span class="close" id="itclose">
              &times;
            </span>
          </div>
          <div className="row">
            <div className="col-md-12">
              {flag && (
                <KendoGrid
                  exportFileName={"Incomingtextreport"}
                  name={"incomingText"}
                  paggable={true}
                  url={`${baseURL}Report/RingCentralSMSLog_Reports?type=${type}&years=${Year}&filter=${filter}&metrics=${value}&value=${value}`}
                  schema={{}}
                  refreshWhen={refreshflag}
                  columns={[
                    {
                      field: "MessageStatus",
                      title: "Direction",
                      width: 100,
                    },
                    {
                      field: "Type",
                      title: "Type",
                      width: 100,
                    },
                    {
                      field: "FromNumber",
                      title: "From Number",
                      width: 140,
                    },
                    {
                      field: "ToNumber",
                      title: "To Number",
                      width: 140,
                    },
                    {
                      field: "FromName",
                      title: "From Name",
                      template: function (dataItem) {
                        return $("<div/>").html(dataItem.FromName).text();
                      },
                      width: 150,
                    },
                    // {
                    //   field: "ToName",
                    //   title: "To Name",
                    //   width: 150,
                    // },
                    {
                      field: "Date",
                      title: "Sms Date",
                      width: 110,
                    },
                    {
                      field: "Time",
                      title: "Sms Time",
                      width: 110,
                    },
                    {
                      field: "ReadStatus",
                      title: "Read Status",
                      width: 100,
                    },
                  ]}
                  height={400}
                  showOptions={false}
                  showEdit={false}
                  showDelete={false}
                />
              )}
            </div>
          </div>
        </div>
      </div>
      {/* <!-- Incoming Text PDF Modal --> */}
      <PdfModal
        chart={
          <BarChart
            labels={xAxisLabel}
            Bardata={data}
            type={"x"}
            XAxisLabel={type}
            YAxisLabel={"Count"}
            id={"PDFIncomingcall"}
          />
        }
        modalId={"INTextPDFmodal"}
        modalcloseId={"INTextPDFclose"}
        modalTitle={"Incoming Text"}
        PDFDownload={() =>
          downloadPDF("PDFIncomingcall", "Incoming Text", 90, 3)
        }
      />
      {/* <!-- End Incoming Text PDF Modal/ --> */}
    </div>
  );
};

export default IncomingText;
